const env = (envName) => {
    const value = process.env?.[envName];
    if (value === undefined) {
        console.warn(`⚠️ Env variable "${envName}" is not defined`);
    }
    return value;
};


export default env;